module.exports = __webpack_public_path__ + "img/gear_white.e077b02a.png";